export default class SitePackage {
  public id: number
  public name: string
  public description: string
  public price: number
  public isPriceUpdated: boolean // property to check product price updated or not - required for front-end
  public isDeleted: boolean
}
